import { createEvent, createStore } from 'effector';

// * events
export const showCookieConsentEvent = createEvent<boolean>();

// * stores
export const $cookieConsent = createStore(false).on(showCookieConsentEvent, (_, payload) => payload);
